import React, { Fragment } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { HeartStraight } from 'phosphor-react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { useOpenSaveSearchDialogHook } from '../../../../hooks/saveSearchHooks';
import {
  SaveSearchIcon,
  SaveSearchGreyIcon,
  SaveSearchWhiteIcon,
} from '../../../utility/Icons';
import SavedSearchPopup from './SavedSearchPopup';

import style from '../../../../styles/sass/pages/Search.module.scss';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    floatingActionButton: {
      backgroundColor: '#ffffff',
      borderRadius: '50%',
      boxShadow: '0 0 4px 1px rgba(0, 0, 0, 0.25)',
      height: 60,
      padding: 0,
      width: 60,
      zIndex: 10,
      marginBottom: '15px',
      '&:hover': {
        backgroundColor: '#BFBFBF',
        boxShadow: 'none',
      },
    },
  }),
);

const SaveSearchButton = ({
  className = '',
  floatingActionButton = false,
  mobileButton = false,
  webButton = false,
  mobileClasses,
}: {
  className?: string;
  floatingActionButton?: boolean;
  mobileButton?: boolean;
  webButton?: boolean;
  mobileClasses?: any;
}) => {
  const classes = styles();
  const {
    savedSearch,
    savedSearchesLoading,
    saveSearchHandler,
  } = useOpenSaveSearchDialogHook();

  if (mobileButton) {
    return (
      <Fragment>
        <Button
          className={`${style.mobileSaveSearchFab} mobile-only`}
          classes={{ label: mobileClasses.button }}
          disabled={savedSearchesLoading}
          onClick={saveSearchHandler}
        >
          {savedSearchesLoading ? (
            <CircularProgress
              size={24}
              variant="indeterminate"
              color="inherit"
            />
          ) : (
            <Fragment>
              <SaveSearchIcon width={25} height={25} />
              <p className={mobileClasses.buttonText}>
                {savedSearch ? 'Saved' : 'Save'}
              </p>
            </Fragment>
          )}
        </Button>

        <SavedSearchPopup />
      </Fragment>
    );
  }

  if (webButton) {
    return (
      <Fragment>
        <SavedSearchPopup />
        <Button
          className={
            savedSearch ? style.webSavedSearchFab : style.webSaveSearchFab
          }
          classes={{ label: style.webButtonLabel }}
          disabled={savedSearchesLoading}
          onClick={saveSearchHandler}
        >
          {savedSearchesLoading ? (
            <CircularProgress
              size={24}
              variant="indeterminate"
              color="inherit"
            />
          ) : (
            <Fragment>
              {savedSearch ? (
                <SaveSearchWhiteIcon width={24} height={24} />
              ) : (
                <SaveSearchGreyIcon width={24} height={24} />
              )}
              <p className={style.webButtonText}>
                {savedSearch ? 'Saved' : 'Save'}
              </p>
            </Fragment>
          )}
        </Button>
      </Fragment>
    );
  }

  if (floatingActionButton) {
    return (
      <Button
        className={`${classes.floatingActionButton} ${className}`}
        disabled={savedSearchesLoading}
        onClick={saveSearchHandler}
      >
        {savedSearchesLoading ? (
          <CircularProgress size={24} variant="indeterminate" color="inherit" />
        ) : (
          <Fragment>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textTransform: 'capitalize',
              }}
            >
              <SaveSearchIcon SaveSearchGreyIconwidth="24" height="24" />

              <div style={{ fontSize: '12px' }}>
                {savedSearch ? 'Saved' : 'Save'}
              </div>
            </div>

            <SavedSearchPopup />
          </Fragment>
        )}
      </Button>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        margin: '0 5px 0 0',
        marginLeft: 18,
        flex: 1,
        justifyContent: 'flex-end',
      }}
      className={className}
    >
      <Button
        disabled={savedSearchesLoading}
        style={{
          backgroundColor: savedSearch ? '#463264' : '#FFFFFF',
          width: '134px',
          height: '40px',
          border: '1px solid #463264',
        }}
        onClick={saveSearchHandler}
      >
        {savedSearchesLoading ? (
          <CircularProgress size={24} variant="indeterminate" color="inherit" />
        ) : (
          <Fragment>
            <SavedSearchPopup />
            <HeartStraight
              size={16}
              color={savedSearch ? '#FFFFFF' : '#463264'}
              weight={savedSearch ? 'fill' : 'regular'}
            />
            <p
              style={{
                color: savedSearch ? '#FFFFFF' : '#463264',
                paddingLeft: '6px',
                textTransform: 'none',
                fontSize: '16px',
              }}
            >
              {savedSearch ? 'Saved Search' : 'Save Search'}
            </p>
          </Fragment>
        )}
      </Button>
    </div>
  );
};

export default SaveSearchButton;
